import { render, staticRenderFns } from "./ResetWindow.vue?vue&type=template&id=219e7e64&scoped=true&"
import script from "./ResetWindow.vue?vue&type=script&lang=js&"
export * from "./ResetWindow.vue?vue&type=script&lang=js&"
import style0 from "./ResetWindow.vue?vue&type=style&index=0&id=219e7e64&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219e7e64",
  null
  
)

export default component.exports